




import LookUp from '@/components/lookup/Index.vue'
import Vue from 'vue'


export default Vue.extend({
    name: 'GeneralSearchView',
    components: {
        LookUp
    },
})
